//
//
//
//
//
//
//
//
//

export default {
  props: ["controlItem"],
  data() {
    return {
      currentRate: 0,
      rate:"70"
    };
  },
  created() {},

  methods: {},
  computed: {
    text() {
      return this.currentRate.toFixed(0) + "%";
    }
  }
};
